// src/pages/ViewSignature.tsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

// Replace with your actual backend URL
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

export default function ViewSignature() {
  const [signatureData, setSignatureData] = useState<{
    signatureUrl: string;
    userName: string;
  } | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // CHANGE THIS: Use real logged-in user email (from MSAL, context, etc.)
  const currentUserEmail = "kinjalpatel072003@gmail.com"; // ← Replace with real user email

  useEffect(() => {
    const fetchSignature = async () => {
      try {
        // This calls your backend to get signature by email
        const res = await axios.get(`${API_BASE}/api/user-signature?email=${encodeURIComponent(currentUserEmail)}`);

        if (res.data.signatureUrl) {
          setSignatureData({
            signatureUrl: res.data.signatureUrl,
            userName: res.data.userName || "User",
          });
        }
      } catch (err: any) {
        console.error("Failed to load signature:", err.response?.data || err.message);
        // Don't show error — just show "no signature"
      } finally {
        setLoading(false);
      }
    };

    fetchSignature();
  }, []);

  return (
     <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'Segoe UI', sans-serif" }}>
      {/* BLUE HEADER WITH NAV BUTTONS */}
      <header style={{
        background: "linear-gradient(90deg, #003f7d, #005eb8)",
        color: "white",
        padding: "60px 40px 100px",
        textAlign: "center"
      }}>
        <h1 style={{ fontSize: "2.5rem", margin: "0 0 12px 0", fontWeight: "700" }}>
          Digital Document Signing System
        </h1>
        <p style={{ fontSize: "1.3rem", margin: "0 0 40px 0", opacity: 0.9, letterSpacing: "1px" }}>
          FAST • SECURE • PAPERLESS
        </p>

        {/* NAVIGATION PILLS */}
  <div style={{ display: "flex", justifyContent: "center", gap: "16px", flexWrap: "wrap" }}>
          <button  onClick={() => navigate("/Home")}style={{ padding: "10px 24px", borderRadius: "30px", border: "none", background: "rgba(255,255,255,0.25)", color: "white", fontWeight: "500", cursor: "pointer" }}>Dashboard</button>
          <button  onClick={() => navigate("/createsign")} style={{ padding: "10px 24px", borderRadius: "30px", border: "none", background: "rgba(255,255,255,0.25)", color: "white", fontWeight: "500", cursor: "pointer" }}>Create Signature</button>
          <button style={{ padding: "12px 28px", borderRadius: "30px", border: "none", background: "white", color: "#003f7d", fontWeight: "600", cursor: "pointer", boxShadow: "0 4px 15px rgba(0,0,0,0.1)" }}>View Signature</button>
          <button onClick={() => navigate("/UploadSign")}style={{ padding: "10px 24px", borderRadius: "30px", border: "none", background: "rgba(255,255,255,0.25)", color: "white", fontWeight: "500", cursor: "pointer" }}>Upload & Sign</button>
          <button onClick={() => navigate("/documents")}style={{ padding: "10px 24px", borderRadius: "30px", border: "none", background: "rgba(255,255,255,0.25)", color: "white", fontWeight: "500", cursor: "pointer" }}>View Documents</button>
        </div>
      </header>

      {/* === MAIN WHITE CARD === */}
      <div
        style={{
          maxWidth: "1000px",
          margin: "-90px auto 120px",
          background: "white",
          borderRadius: "32px",
          boxShadow: "0 25px 70px rgba(0,0,0,0.15)",
          padding: "80px 100px",
          textAlign: "center",
          position: "relative",
          zIndex: 10,
        }}
      >
        <h2
          style={{
            fontSize: "2rem",
            color: "#003f7d",
            margin: "0 0 70px 0",
            fontWeight: "600",
          }}
        >
          Saved Signature
        </h2>

        {loading ? (
          <div style={{ padding: "80px", color: "#666", fontSize: "1.4rem" }}>
            Loading your signature...
          </div>
        ) : signatureData ? (
          <>
            {/* SIGNATURE DISPLAY BOX */}
            <div
              style={{
                background: "#f8f9fa",
                border: "3px dashed #dee2e6",
                borderRadius: "20px",
                padding: "60px 100px",
                margin: "0 auto 60px",
                maxWidth: "700px",
                boxShadow: "inset 0 4px 15px rgba(0,0,0,0.06)",
              }}
            >
              <img
                src={signatureData.signatureUrl}
                alt="Your saved signature"
                style={{
                  maxWidth: "100%",
                  maxHeight: "200px",
                  objectFit: "contain",
                  filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.2))",
                }}
              />
            </div>

            {/* USER NAME */}
            <p
              style={{
                fontSize: "2rem",
                color: "#333",
                margin: "30px 0 60px",
                fontWeight: "500",
                letterSpacing: "1px",
              }}
            >
              {signatureData.userName}
            </p>

            {/* MODIFY BUTTON */}
            <button
              onClick={() => navigate("/createsign")}
              style={{
                width: "100%",
                padding: "24px",
                fontSize: "1.7rem",
                fontWeight: "bold",
                color: "white",
                background: "linear-gradient(135deg, #003f7d, #005eb8)",
                border: "none",
                borderRadius: "18px",
                cursor: "pointer",
                boxShadow: "0 12px 35px rgba(0,63,125,0.4)",
                transition: "all 0.3s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 20px 40px rgba(0,63,125,0.5)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,63,125,0.4)";
              }}
            >
              Modify Signature
            </button>
          </>
        ) : (
          // NO SIGNATURE YET
          <div>
            <p style={{ fontSize: "1.6rem", color: "#666", marginBottom: "40px" }}>
              You haven't created a digital signature yet.
            </p>
            <button
              onClick={() => navigate("/createsign")}
              style={{
                padding: "18px 50px",
                fontSize: "1.4rem",
                background: "#005eb8",
                color: "white",
                border: "none",
                borderRadius: "14px",
                cursor: "pointer",
                boxShadow: "0 8px 25px rgba(0,94,184,0.3)",
              }}
            >
              Create Your Signature Now
            </button>
          </div>
        )}
      </div>
    </div>
  );
}